"use client"
import React from "react";
import "@/components/locator/LocatorSearchResultPreview.css";
import { Ratio } from "react-bootstrap";
import UralityImage from "@/components/shared/UralityImage";
import "@/components/locator/re/RESearchResultPreview.css";
import { underDevelopmentLabel } from "@/components/crm/pau/re/reListingAvailability";

const RESearchResultPreview = ({ item, showThumbnail, upperRight }) => {
  const RESearchResultDetails = () => {
    const areaSqFt = item?.unitSnapshot?.areaSqFt
      ? `${item?.unitSnapshot?.areaSqFt} sq ft`
      : item?.areaSqFt
      ? `${item?.areaSqFt} sq ft`
      : null;
    const rentVal = item?.monthlyRent ?? item?.unitSnapshot?.monthlyRent;
    const monthlyRent =
      rentVal != null && rentVal !== ""
        ? `$${rentVal} per mo`
        : null;
    const rateVal = item?.rentPerSqFtYear ?? item?.unitSnapshot?.rentPerSqFtYear;
    const rentPerSqFt =
      rateVal != null && rateVal !== "" ? `$${rateVal}/SF/yr` : null;
    const priceVal = item?.salePrice ?? item?.unitSnapshot?.salePrice;
    const salePrice =
      priceVal != null && priceVal !== "" ? `$${priceVal}` : null;
    const unitType = item?.unitSnapshot?.type
      ? formatEnumValue(item?.unitSnapshot.type)
      : item?.unitType
      ? formatEnumValue(item?.unitType)
      : null;
    const saleOrLease =
      item?.saleOrLease ?? item?.unitSnapshot?.saleOrLease ?? null;

    return (
      <div className="default-flex-column-layout" style={{ gap: "0.05rem" }}>
        {unitType && <span>{unitType}</span>}
        {areaSqFt && <span>{areaSqFt}</span>}
        {saleOrLease === "LEASE" && monthlyRent && <span>{monthlyRent}</span>}
        {saleOrLease === "LEASE" && rentPerSqFt && <span>{rentPerSqFt}</span>}
        {saleOrLease === "SALE" && salePrice && <span>{salePrice}</span>}
        {saleOrLease === "UNDER_DEVELOPMENT" && (
          <span className="re-under-development">
            {underDevelopmentLabel(item?.expectedCompletion)}
          </span>
        )}
      </div>
    );
  };

  const formatEnumValue = value => {
    if (!value) return null;
    return value
      .toString()
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase()
      .replace(/(^|\s)\S/g, char => char.toUpperCase());
  };

  const addressLine1 = item?.addressSnapshot
    ? item?.addressSnapshot.addressLine1
    : item?.addressLine1;
  const addressLine2 = item?.addressSnapshot
    ? `${item?.addressSnapshot?.city}, ${item?.addressSnapshot?.region} ${item?.addressSnapshot?.postcode}`
    : null;

  return (
    <>
      <div className="locator-search-result-preview">
        <div className="left-side">
          <div className="locator-search-result-item-name">
            <h5 style={{ marginBottom: "0.25rem" }}>{addressLine1}</h5>
            {addressLine2 && (
              <span style={{ marginBottom: "0.25rem" }}>{addressLine2}</span>
            )}
          </div>
          <RESearchResultDetails item={item} />
        </div>
        <div className="right-side">
          {showThumbnail && item?.selectedImages?.length > 0 ? (
            <Ratio aspectRatio="16x9" className="thumbnail">
              <UralityImage imageId={item?.selectedImages[0]} size="sm">
                {upperRight}
              </UralityImage>
            </Ratio>
          ) : (
            <>{upperRight}</>
          )}
        </div>
      </div>
    </>
  );
};

export default RESearchResultPreview;
